'use client';
import React, { FC } from 'react';
// import style from './ContentWeOffer.module.scss';
import { Icons } from '@/components/icons';
import { motion, useInView } from 'framer-motion';

interface IProps {
  title: string;
  items: { title: string; list: { title: string }[] }[];
}

export const ContentWeOffer: FC<IProps> = ({ title, items }) => {
  // Создаем реф для проверки видимости
  const sectionRef = React.useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, { once: true }); // Проверяем, находится ли элемент в области видимости

  return (
    <div ref={sectionRef}>
      <motion.h3
        className="mb-14 text-left text-4xl font-semibold"
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        {title}
      </motion.h3>
      <ul className="flex flex-col gap-y-6 ">
        {items.map((item) => (
          <motion.li
            key={item.title}
            className="flex flex-col font-semibold md:flex-row md:justify-between"
            initial={{ opacity: 0, y: 10 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex w-full items-start gap-2">
              <span>
                <Icons.serviceIcon />
              </span>
              <span className="text-left text-xl">{item.title}</span>
            </div>
            <ul className="flex w-full list-disc flex-col gap-y-1.5 pl-10 md:pl-0">
              {item.list.map((subItem, index) => (
                <motion.li
                  key={subItem.title}
                  className="description-with-links text-left text-base font-normal"
                  initial={{ opacity: 0, y: 10 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  exit={{ opacity: 0, y: 10 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  dangerouslySetInnerHTML={{ __html: subItem.title }}
                />
              ))}
            </ul>
          </motion.li>
        ))}
      </ul>
    </div>
  );
};
